import React from 'react';
import App from './App';
import ReactDOM from 'react-dom'

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
)